import { useId, useRef } from 'react';
import s from './attach-file-modal.module.scss';
import classNames from 'classnames';
import { IconUpload, IconX } from '@tabler/icons-react';
import { toast } from 'react-toastify';
import { formatFileSize } from '@utils/lib/formatFileSize';
import { getExtension } from '@entities/attachment';
import { FileTypeIcon } from '../../model/file-type-icon';

/** Вкладка «С устройства» — выбор локального файла (загрузка происходит в момент прикрепления). */
export const ComputerTab = ({ selected, multiple, maxFiles, onlyCategory, maxSize, onAdd, onRemove }) => {
	const inputRef = useRef(null);
	const id = useId();

	const remaining = maxFiles - selected.length;

	const handleChange = (event) => {
		const files = Array.from(event.target.files || []);
		event.target.value = '';
		if (!files.length) return;

		let accepted = files;
		if (maxSize) {
			accepted = files.filter((file) => {
				if (file.size > maxSize) {
					toast.error(`«${file.name}» больше ${formatFileSize(maxSize)}`);
					return false;
				}
				return true;
			});
		}

		onAdd(accepted.slice(0, Math.max(remaining, 0)));
	};

	return (
		<div className={s.tabBody}>
			<button
				type="button"
				className={classNames(s.dropArea, remaining <= 0 && s.disabled)}
				onClick={() => remaining > 0 && inputRef.current?.click()}
				disabled={remaining <= 0}
			>
				<IconUpload size={28} />
				<span className={s.dropTitle}>
					{remaining > 0 ? 'Выберите файл' : `Можно прикрепить не более ${maxFiles} файлов`}
				</span>
				<span className={s.dropSub}>с устройства</span>
			</button>
			<input
				ref={inputRef}
				id={id}
				type="file"
				className={s.hiddenInput}
				multiple={multiple}
				accept={onlyCategory ? `${onlyCategory}/*` : undefined}
				onChange={handleChange}
			/>

				{selected.length > 0 && (
				<div className={s.fileList}>
					{selected.map((file, index) => (
						<div className={s.fileRow} key={`${file.name}-${index}`}>
							<FileTypeIcon extension={getExtension(file)} />
							<span className={s.fileMeta}>
								<span className={s.fileName}>{file.name || 'Файл'}</span>
								<span className={s.fileSub}>{formatFileSize(file.size)}</span>
							</span>
							<button
								type="button"
								className={s.removeBtn}
								onClick={() => onRemove(file)}
								title="Убрать"
							>
								<IconX size={16} />
							</button>
						</div>
					))}
				</div>
			)}
		</div>
	);
};
